export const GRAPHEME_LIMIT = 3000;
export const GRAPHEMES_REMAINING_TO_WARN = 10;
